import { useContext } from 'react';

import AppContext from '../context/AppContext';

/**
 * @summary Supply information about whether or not traffic is from the US,
 * using the Next.js's app context.
 * Supplies `isUsTraffic` to the incoming component.
 *
 * @param {React.JSXElementConstructor<any>} Component Component, preferably page, to apply this behaviour to.
 */
export function withUSGeoBlocking(Component) {
	return ({ ...props }) => {
		const { isUsTraffic } = useContext(AppContext);

		return <Component {...props} isUsTraffic={isUsTraffic} />;
	};
}
